var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImage131(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_131",
    "data-name": "Group 131",
    transform: "translate(-46 -434)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "customer-satisfaction",
    transform: "translate(46 434)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_137",
    "data-name": "Path 137",
    d: "M264.165,0h.3a6.42,6.42,0,0,1,6.244,6.248v.331a6.406,6.406,0,0,1-8.861,5.722.132.132,0,0,0-.1,0q-1.965.677-3.919,1.356a.024.024,0,0,1-.03-.03l1.239-3.566a.043.043,0,0,0,0-.039A6.407,6.407,0,0,1,264.165,0Zm-3.416,9.791-.476,1.372q-.013.036.024.023l1.566-.545a.049.049,0,0,1,.042,0,4.9,4.9,0,1,0-1.488-1.325q.159.213.325.421A.05.05,0,0,1,260.749,9.791Z",
    transform: "translate(-244.713)",
    fill: "#f45000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_138",
    "data-name": "Path 138",
    d: "M16.322,80.942h-.24a7.369,7.369,0,0,1-4.465-1.613,12.769,12.769,0,0,1-1.032-.962Q6.449,74.236,2.322,70.1A7.434,7.434,0,0,1,0,64.968V64.5a7.338,7.338,0,0,1,1.764-4.536c.608-.716,1.361-1.4,2.04-2.077a.015.015,0,0,1,.022,0L9.836,63.9a.023.023,0,0,1,0,.032L7.392,66.371a.022.022,0,0,0-.007.016.023.023,0,0,0,.007.016l7.151,7.151a.018.018,0,0,0,.025,0l2.444-2.444a.024.024,0,0,1,.038,0l6,6a.022.022,0,0,1,.007.016.023.023,0,0,1-.007.016q-.724.73-1.458,1.454-.475.468-.746.689A7.314,7.314,0,0,1,16.322,80.942ZM7.681,63.9,3.848,60.066a.039.039,0,0,0-.062,0A10.063,10.063,0,0,0,2.65,61.292a5.84,5.84,0,0,0,.521,7.5q4.448,4.451,8.9,8.9a5.8,5.8,0,0,0,7.978.258q.434-.387.837-.8a.03.03,0,0,0,0-.042L17.05,73.268a.027.027,0,0,0-.038,0l-2.441,2.441a.023.023,0,0,1-.032,0l-9.3-9.3a.024.024,0,0,1,0-.038l2.444-2.444a.018.018,0,0,0,0-.025Z",
    transform: "translate(0 -54.942)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_140",
    "data-name": "Rectangle 140",
    width: 1.523,
    height: 1.523,
    rx: 0.65,
    transform: "translate(17.316 3.783)",
    fill: "#f45000"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_141",
    "data-name": "Rectangle 141",
    width: 1.523,
    height: 1.523,
    rx: 0.65,
    transform: "translate(20.363 3.783)",
    fill: "#f45000"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_139",
    "data-name": "Path 139",
    d: "M341.09,135.785a2.282,2.282,0,0,1,4.563-.013.035.035,0,0,1-.035.036h-1.449a.032.032,0,0,1-.035-.031.767.767,0,0,0-1.531,0,.03.03,0,0,1-.033.028h-1.457A.021.021,0,0,1,341.09,135.785Z",
    transform: "translate(-323.769 -126.744)",
    fill: "#f45000"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImage131);
export default __webpack_public_path__ + "static/media/Image-131.08893c11194df0af9889f9de7b8bce3b.svg";
export { ForwardRef as ReactComponent };